import React, { useRef } from "react";
import { AccordionIcon } from "./Accordion";
import { PlusMinusIcon } from "./icons";
import { ExpandMore } from "@mui/icons-material";

type ChevronIconProps = {
  expanded: boolean;
};

const ChevronIcon = (props: ChevronIconProps) => {
  return (
    <div className={`transition ${props.expanded ? "rotate-180" : ""}`}>
      <ExpandMore fontSize="large" />
    </div>
  );
};

export interface AccordionItemProps {
  id: string;
  title: React.ReactNode | string;
  content: React.ReactNode | string;
  open: boolean;
  onChange?: () => void;
  icon?: AccordionIcon;
}

export const AccordionItem = ({
  id,
  title,
  content,
  open,
  onChange,
  icon = "plus-minus",
}: AccordionItemProps) => {
  return (
    <li id={`accordion-item${id}`}>
      <button
        className="group my-5 flex w-full items-center justify-between space-x-4 border-0 bg-transparent px-0 text-left"
        aria-expanded={open}
        aria-controls={`accordion-content${id}`}
        onClick={onChange}
      >
        <span id={`accordion-title${id}`} className="font-semibold">
          {title}
        </span>
        <div aria-hidden="true">
          {icon == "plus-minus" ? (
            <PlusMinusIcon expanded={open} />
          ) : (
            <ChevronIcon expanded={open} />
          )}
        </div>
      </button>
      <div
        id={`accordion-content${id}`}
        aria-labelledby={`accordion-item${id}`}
        role="region"
        className={`h-0 overflow-hidden transition-all ${open ? "mb-5" : ""}`}
        style={open ? { height: "auto" } : { height: "0px", display: "none" }}
      >
        {content}
      </div>
    </li>
  );
};
